import { Component } from "react";
import { connect } from "react-redux";
import { compose } from "redux";
import Card from "@mui/material/Card";
import Button from "@mui/material/Button";
import Fab from "@mui/material/Fab";
import CardContent from "@mui/material/CardContent";
import { formatStatus } from "../../../redux/intervention/interventionStatusActions";
import GoogleDriveIcon from "../../../images/google-drive-icon.png";
import Icon from "@mui/material/Icon/Icon";
import moment from "moment";
import { formatAddress } from "../../../utils";
import WorkerIcon from "../../../images/worker-hat-icon.png";
import InterventionStatusIcon from "../InterventionStatusIcon";
import { generateTotalTimeSpentOnWorkOrder } from "../../../redux/intervention/interventionActions";
import qrCodeLogo from "../../../images/qr-code-icon.png";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import CloseIcon from "@mui/icons-material/Close";
import CustomerIcon from "@mui/icons-material/AssignmentInd";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import { withStyles } from "@mui/styles";
import ComponentPark from "../../../containers/ComponentsPark/ComponentPark";
import VerifiedUserIcon from "@mui/icons-material/VerifiedUser";
import { searchComponent, clearComponentsSearch } from "../../../redux/componentsPark/componentsParkActions";
import { customerSearch, clearCustomerSearch } from "../../../redux/tiers/tiersActions";
import CustomizedTextField from "../../Input/CustomizedTextField";
import { getCurrentFunctionName } from "../../../performanceModeManager";
import CustomerModal from "../../Customers/CustomerModal";
import {
    clearSPPSearch,
    downloadSPP,
    searchSPP,
} from "../../../redux/simplifiedPreventPlan/simplifiedPreventPlanActions";

const styles = {
    appBar: {
        position: "relative",
        marginBottom: "10px",
    },
    flex: {
        flex: 1,
    },
};

class DetailTab extends Component {
    constructor(props) {
        super(props);
        this.state = {
            modalEquipmentOpen: false,
            customerModalOpenned: false,
        };

        if (this.props.intervention.equipment_id)
            this.props.searchComponent(this.props.intervention.equipment_code, true);
        else this.props.clearComponentsSearch();

        if (
            this.props.intervention.delivery_customer_id &&
            this.props.intervention.delivery_customer_id.customer_code
        ) {
            this.props.customerSearch(
                this.props.intervention.delivery_customer_id.customer_code,
                this.props.activeUser
            );
            this.props.searchSPP(
                this.props.intervention.delivery_customer_id.id,
                this.props.intervention.date_planned_start
            );
        } else {
            this.props.clearCustomerSearch();
            this.props.clearSPPSearch();
        }
    }

    shouldComponentUpdate(nextProps, nextState) {
        return (
            this.props.intervention !== nextProps.intervention ||
            this.state.modalEquipmentOpen !== nextState.modalEquipmentOpen ||
            this.props.componentsPark.currentComponent !== nextProps.componentsPark.componentPark ||
            this.state.customerModalOpenned !== nextState.customerModalOpenned ||
            this.props.customerFound !== nextProps.customerFound ||
            this.props.sppFound !== nextProps.sppFound
        );
    }

    launchMaps() {
        let address;

        if (this.props.intervention.delivery_address_id) address = this.props.intervention.delivery_address_id;
        else address = this.props.intervention.delivery_customer_id;

        if (!address) return;

        let strAddress = address.street.concat(address.zip).concat(" ").concat(address.city);

        let uri = "geo:?q=";
        uri = uri.concat(encodeURIComponent(strAddress));
        window.open(uri);
    }

    openDriveLink(link) {
        if (!link) return;

        var win = window.open(link, "_blank");

        if (win) win.focus();
    }

    actualizeTimeSpent() {
        this.forceUpdate();
    }

    onEquipmentClick() {
        if (this.props.componentsPark.currentComponent)
            this.setState({
                modalEquipmentOpen: true,
            });
    }

    onCustomerClick() {
        if (this.props.customerFound)
            this.setState({
                customerModalOpenned: true,
            });
    }

    onSPPClick() {
        if (this.props.sppFound) this.props.downloadSPP(this.props.sppFound, this.props.activeUser);
    }

    closeEquipment() {
        this.setState({
            modalEquipmentOpen: false,
        });
    }

    closeCustomer() {
        this.setState({
            customerModalOpenned: false,
        });
    }

    render() {
        console.perfLog(getCurrentFunctionName());
        const { classes } = this.props;

        let intervenantsStrList = "";
        let address;
        let strAddress;
        let strCustomer = "";

        if (this.props.intervention.delivery_address_id) address = this.props.intervention.delivery_address_id;
        else address = this.props.intervention.delivery_customer_id;

        strAddress = address ? formatAddress(address) : "";

        this.props.intervention.technician_ids.forEach((t, i) => {
            if (i !== 0) intervenantsStrList = intervenantsStrList.concat(", ");

            intervenantsStrList = intervenantsStrList.concat(t.name_related);
        });

        if (this.props.intervention.delivery_customer_id)
            strCustomer =
                this.props.intervention.delivery_customer_id.name +
                " [" +
                this.props.intervention.delivery_customer_id.id +
                "]";

        let totalTimeSpent = generateTotalTimeSpentOnWorkOrder(this.props.intervention, this.props.blocTypes);
        let nbHours = parseInt(totalTimeSpent);
        let nbMinutes = parseInt((totalTimeSpent - nbHours) * 60);
        let displayableTotalTimeSpent = nbHours + "h " + (nbMinutes < 10 ? "0" : "") + nbMinutes + "min";

        return (
            <Card className="col-lg-12 col-md-12 col-sm-12 col-12 card card-margin-top without-side-padding">
                <CardContent className="without-side-padding">
                    <div className="row">
                        <div className="col-lg-6 col-md-6 col-sm-12 col-12 row">
                            <div className="col-lg-10 col-md-10 col-sm-10 col-9 without-side-padding">
                                <CustomizedTextField
                                    value={strCustomer}
                                    id="customer"
                                    multiline
                                    label="Client"
                                    className="full_size light-disabled control-margin-top "
                                />
                            </div>
                            {this.props.customerFound ? (
                                <div className="without-side-padding col-lg-2 col-md-2 col-sm-2 col-3 control-inline-btn">
                                    <Button
                                        className="div-center"
                                        variant="contained"
                                        size="small"
                                        onClick={this.onCustomerClick.bind(this)}
                                    >
                                        <CustomerIcon />
                                    </Button>
                                    {this.props.sppFound ? (
                                        <Button
                                            className="div-center"
                                            variant="contained"
                                            size="small"
                                            onClick={this.onSPPClick.bind(this)}
                                        >
                                            <VerifiedUserIcon color="secondary" className={classes.icon} />
                                        </Button>
                                    ) : null}
                                </div>
                            ) : null}
                            <CustomerModal
                                onClose={this.closeCustomer.bind(this)}
                                modalOpenned={this.state.customerModalOpenned}
                            />
                        </div>
                        <div className="col-lg-6 col-md-6 col-sm-12 col-12">
                            <CustomizedTextField
                                value={
                                    this.props.intervention.delivery_contact_id
                                        ? this.props.intervention.delivery_contact_id.phone
                                        : ""
                                }
                                id="phone"
                                label="Téléphone"
                                className="full_size light-disabled control-margin-top"
                            />
                        </div>
                        <div className="col-lg-6 col-md-6 col-sm-12 col-12">
                            <CustomizedTextField
                                value={moment(this.props.intervention.date_planned_start).format("DD/MM/YYYY HH:mm")}
                                id="date"
                                label="Date"
                                className="full_size light-disabled control-margin-top"
                            />
                        </div>
                        <div className="col-lg-6 col-md-6 col-sm-12 col-12 row">
                            <CustomizedTextField
                                InputProps={{
                                    startAdornment: (
                                        <InterventionStatusIcon
                                            state={this.props.intervention.state}
                                            internalState={this.props.intervention.internalState}
                                        />
                                    ),
                                }}
                                value={formatStatus(
                                    this.props.intervention.state,
                                    this.props.intervention.internalState
                                )}
                                id="status"
                                label="Statut"
                                className="full_size light-disabled control-margin-top"
                            />
                        </div>
                        <div className="col-lg-6 col-md-6 col-sm-12 col-12">
                            <CustomizedTextField
                                value={this.props.intervention.name}
                                id="code"
                                label="Code"
                                className="full_size light-disabled control-margin-top"
                            />
                        </div>
                        <div className="col-lg-6 col-md-6 col-sm-12 col-12">
                            <CustomizedTextField
                                value={this.props.intervention.allocation_label}
                                id="type"
                                label="Type"
                                className="full_size light-disabled control-margin-top"
                            />
                        </div>
                        <div className="col-lg-6 col-md-6 col-sm-12 col-12">
                            <CustomizedTextField
                                value={this.props.intervention.affair_id ? this.props.intervention.affair_id.code : ""}
                                id="affair"
                                label="Affaire"
                                className="full_size light-disabled control-margin-top "
                            />
                        </div>
                        <div className="col-lg-6 col-md-6 col-sm-12 col-12">
                            <CustomizedTextField
                                value={this.props.intervention.affair_id ? this.props.intervention.affair_id.name : ""}
                                id="affair-label"
                                multiline
                                label="Libellé affaire"
                                className="full_size light-disabled control-margin-top "
                            />
                        </div>
                        <div className="col-lg-6 col-md-6 col-sm-12 col-12 row">
                            <div className="col-lg-10 col-md-10 col-sm-10 col-9 without-side-padding">
                                <CustomizedTextField
                                    value={
                                        this.props.intervention.equipment_description
                                            ? this.props.intervention.equipment_description
                                            : ""
                                    }
                                    id="equipment"
                                    label="Equipement"
                                    className="full_size light-disabled control-margin-top"
                                    multiline
                                />
                            </div>
                            {this.props.componentsPark.currentComponent ? (
                                <div className="col-lg-2 col-md-2 col-sm-2 col-3 control-inline-btn">
                                    <Button
                                        className="div-center"
                                        variant="contained"
                                        size="small"
                                        onClick={this.onEquipmentClick.bind(this)}
                                    >
                                        <img src={qrCodeLogo} alt="QR code" width={32} height={32} />
                                    </Button>
                                </div>
                            ) : null}
                            <Dialog
                                open={this.state.modalEquipmentOpen}
                                onClose={this.closeEquipment}
                                fullScreen
                                aria-labelledby="form-dialog-title"
                            >
                                <AppBar className={classes.appBar} elevation={0}>
                                    <Toolbar>
                                        <IconButton
                                            color="inherit"
                                            onClick={this.closeEquipment.bind(this)}
                                            aria-label="Close"
                                        >
                                            <CloseIcon />
                                        </IconButton>
                                        <Typography variant="h6" color="inherit" className={classes.flex}>
                                            {"Equipement"}
                                        </Typography>
                                    </Toolbar>
                                </AppBar>
                                <Toolbar />
                                <DialogContent className="without-side-padding">
                                    <ComponentPark blockOtherScan />
                                </DialogContent>
                            </Dialog>
                        </div>
                        <div className="col-lg-6 col-md-6 col-sm-12 col-12">
                            <CustomizedTextField
                                multiline
                                value={
                                    this.props.intervention.failure_description
                                        ? this.props.intervention.failure_description
                                        : ""
                                }
                                id="failure-description"
                                label="Panne"
                                className="full_size light-disabled control-margin-top"
                            />
                        </div>
                        <div className="col-lg-6 col-md-6 col-sm-12 col-12">
                            <CustomizedTextField
                                InputProps={{
                                    inputProps: {
                                        className: "hidden",
                                        //On cache l'input et on le remplace par un startAdornment (qui lui accepte un élément HTML)
                                    },
                                    startAdornment: (
                                        <div className="element-as-textfield-value row">
                                            {this.props.intervention.technician_ids.map((t, i) => {
                                                let strIntervenant = "";
                                                let iconElement = null;

                                                if (!t.name_related) return "";

                                                if (i !== 0) strIntervenant = strIntervenant.concat(", ");

                                                if (t.id === this.props.intervention.tec_manager_id.id)
                                                    iconElement = (
                                                        <img src={WorkerIcon} alt="" width="12px" height="12px" />
                                                    );

                                                strIntervenant = strIntervenant.concat(t.name_related);

                                                return (
                                                    <div key={i} className="part-of-element-as-textfield-value">
                                                        {strIntervenant}
                                                        {iconElement ? " (" : ""}
                                                        {iconElement}
                                                        {iconElement ? ")" : ""}
                                                    </div>
                                                );
                                            })}
                                        </div>
                                    ),
                                }}
                                id="technicians"
                                label="Techniciens"
                                multiline
                                className="full_size light-disabled control-margin-top"
                            />
                        </div>
                        <div className="col-lg-6 col-md-6 col-sm-12 col-12">
                            <CustomizedTextField
                                value={
                                    this.props.intervention.duration_planned
                                        ? this.props.intervention.duration_planned
                                        : ""
                                }
                                id="duration"
                                label="Durée"
                                className="full_size light-disabled control-margin-top"
                            />
                        </div>
                        <div className="col-lg-6 col-md-6 col-sm-12 col-12 row">
                            <div className="without-side-padding col-lg-10 col-md-10 col-sm-10 col-9">
                                <CustomizedTextField
                                    value={strAddress}
                                    id="address"
                                    label="Adresse"
                                    multiline
                                    className="full_size light-disabled control-margin-top"
                                />
                            </div>
                            <div className="without-side-padding col-lg-2 col-md-2 col-sm-2 col-3 control-inline-btn">
                                <Button
                                    variant="contained"
                                    size="small"
                                    onClick={this.launchMaps.bind(this)}
                                    className="div-center"
                                >
                                    <Icon>location_on</Icon>
                                </Button>
                            </div>
                        </div>
                        <div className="col-lg-6 col-md-6 col-sm-12 col-12 row">
                            <div className="without-side-padding col-lg-10 col-md-10 col-sm-10 col-9">
                                <CustomizedTextField
                                    value={displayableTotalTimeSpent}
                                    id="totalTimeSpent"
                                    label="Temps passé sur l'intervention"
                                    className="full_size light-disabled control-margin-top"
                                />
                            </div>
                            <div className="without-side-padding col-lg-2 col-md-2 col-sm-2 col-3 control-inline-btn">
                                <Button
                                    variant="contained"
                                    size="small"
                                    onClick={this.actualizeTimeSpent.bind(this)}
                                    className="div-center"
                                >
                                    <Icon>autorenew</Icon>
                                </Button>
                            </div>
                        </div>
                        <div className="col-lg-6 col-md-6 col-sm-12 col-12">
                            <CustomizedTextField
                                multiline
                                value={this.props.intervention.comment ? this.props.intervention.comment : ""}
                                id="comment"
                                label="Commentaire"
                                className="full_size light-disabled control-margin-top"
                            />
                        </div>
                        <div className="col-lg-6 col-md-6 col-sm-12 col-12">
                            <CustomizedTextField
                                multiline
                                value={
                                    this.props.intervention.internal_comment
                                        ? this.props.intervention.internal_comment
                                        : ""
                                }
                                id="internal-comment"
                                label="Commentaire interne"
                                className="full_size light-disabled control-margin-top"
                            />
                        </div>
                        <div className="row without-side-padding">
                            <div className="col-lg-6 col-md-6 col-sm-6 col-6 center control-margin-top">
                                {this.props.intervention.customer_google_drive_url ? (
                                    <div className="without-side-padding">
                                        <Fab
                                            onClick={this.openDriveLink.bind(
                                                this,
                                                this.props.intervention.customer_google_drive_url
                                            )}
                                            className="div-center"
                                        >
                                            <img src={GoogleDriveIcon} alt="" width="32px" height="32px" />
                                        </Fab>
                                        <span className="span-center">Drive client</span>
                                    </div>
                                ) : null}
                            </div>
                            <div className="col-lg-6 col-md-6 col-sm-6 col-6 center control-margin-top">
                                {this.props.intervention.wo_google_drive_url ? (
                                    <div className="without-side-padding">
                                        <Fab
                                            onClick={this.openDriveLink.bind(
                                                this,
                                                this.props.intervention.wo_google_drive_url
                                            )}
                                            className="div-center"
                                        >
                                            <img src={GoogleDriveIcon} alt="" width="32px" height="32px" />
                                        </Fab>
                                        <span className="span-center">Drive OT</span>
                                    </div>
                                ) : null}
                            </div>
                        </div>
                    </div>
                </CardContent>
            </Card>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        intervention: state.intervention.currentIntervention,
        blocTypes: state.interventions.blocTypes,
        componentsPark: state.componentsPark,
        customerFound: state.tiers.customerSearch,
        sppFound: state.analyseRisques.sppFound,
        activeUser: state.activeUser,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        searchComponent: (code, discreetError) => dispatch(searchComponent(code, discreetError)),
        clearComponentsSearch: () => dispatch(clearComponentsSearch()),
        customerSearch: (code, user) => dispatch(customerSearch(code, user)),
        searchSPP: (customerId, date) => dispatch(searchSPP(customerId, date)),
        clearSPPSearch: () => dispatch(clearSPPSearch()),
        clearCustomerSearch: () => dispatch(clearCustomerSearch()),
        downloadSPP: (spp, user) => dispatch(downloadSPP(spp, user)),
    };
};

export default compose(withStyles(styles), connect(mapStateToProps, mapDispatchToProps))(DetailTab);
